import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ChevronDown, ChevronUp, ClipboardList } from 'lucide-react';
import { fmtDay } from '../porters/porterUi';

export const SEV = {
  high: 'border-red-200 bg-red-50 text-red-900',
  medium: 'border-amber-200 bg-amber-50 text-amber-900',
  low: 'border-slate-200 bg-slate-50 text-slate-700',
};

export const AlertItem = ({ a, onOpen }) => (
  <li className={`rounded-md border px-3 py-2 text-sm flex items-center gap-2 ${SEV[a.severity]}`} data-testid={`alert-${a.type}-${a.ref}`}>
    <AlertTriangle className="w-4 h-4 shrink-0" />
    <span className="flex-1 min-w-0">{a.message}</span>
    <span className="text-xs opacity-80 shrink-0">{fmtDay(a.date)} {a.time}</span>
    {onOpen && <button type="button" onClick={() => onOpen(a.quote_id)} className="text-xs font-bold underline shrink-0" data-testid={`alert-open-${a.ref}-${a.type}`}>Open</button>}
  </li>
);

export const StaffingAlerts = ({ authFetch, onOpen }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const load = useCallback(() => authFetch('get', '/admin/staffing-alerts?days=7').then(({ data }) => setD(data)).catch(() => {}), [authFetch]);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  if (!d) return null;
  const urgent = d.alerts.filter(a => a.severity !== 'low');
  const shown = open ? d.alerts : urgent.slice(0, 5);
  return (
    <section className="mb-6 rounded-xl border border-slate-200 bg-white p-4" data-testid="staffing-alerts">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="font-display text-lg font-extrabold text-[color:var(--mv-navy)] flex items-center gap-2 flex-1">
          <AlertTriangle className="w-5 h-5 text-[color:var(--mv-orange)]" /> Staffing alerts · next 7 days
        </h2>
        <span className="text-xs font-black px-2 py-0.5 rounded-full bg-red-100 text-red-800" data-testid="alerts-high-count">{d.counts.high} urgent</span>
        <span className="text-xs font-black px-2 py-0.5 rounded-full bg-amber-100 text-amber-800" data-testid="alerts-medium-count">{d.counts.medium} to check</span>
        <Link to="/admin/tomorrow" className="h-9 px-3 rounded-md bg-[color:var(--mv-navy)] text-white text-xs font-bold inline-flex items-center gap-1.5" data-testid="alerts-tomorrow-link">
          <ClipboardList className="w-3.5 h-3.5" /> Tomorrow's work
        </Link>
      </div>
      {d.alerts.length === 0
        ? <div className="mt-2 text-sm text-green-700 font-semibold" data-testid="alerts-all-clear">All clear — every job in the next 7 days is staffed and confirmed.</div>
        : <ul className="mt-3 space-y-1.5">{shown.map((a, i) => <AlertItem key={`${a.type}-${a.quote_id}-${i}`} a={a} onOpen={onOpen} />)}</ul>}
      {d.alerts.length > shown.length || open ? (
        <button type="button" onClick={() => setOpen(v => !v)} className="mt-2 h-9 text-sm font-bold text-[color:var(--mv-orange)] inline-flex items-center gap-1" data-testid="alerts-toggle">
          {open ? <><ChevronUp className="w-4 h-4" /> Show fewer</> : <><ChevronDown className="w-4 h-4" /> Show all {d.alerts.length}</>}
        </button>
      ) : null}
    </section>
  );
};
